import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { BaseMap } from 'src/app/shared/api/google-maps/base-map';
import { DarkOverlayMapType } from 'src/app/shared/api/google-maps/dark-overlay-map-type';
import { GeoLocationService } from 'src/app/shared/services/geo-location.service';
import { MapsLoaderService } from 'src/app/shared/services/maps-loader.service';
import { Emergency } from 'src/app/web-api-client';
import { AddEmergencyComponent } from '../../modals/add-emergency/add-emergency.component';

@Component({
  selector: 'app-emergencies-map-view',
  templateUrl: './emergencies-map-view.component.html',
  styleUrls: ['./emergencies-map-view.component.scss']
})
export class EmergenciesMapViewComponent extends BaseMap implements OnInit {
  @ViewChild('map', { static: true }) mapElement: ElementRef<HTMLElement>;
  @Input() emergenciesList: Emergency[] = [];
  @Input() focusView: boolean = true;

  private signalMarkersList: google.maps.marker.AdvancedMarkerElement[] = [];
  private infowindow: google.maps.InfoWindow;

  public mapLoaded = false;

  constructor(
    private readonly changeDetectorRef: ChangeDetectorRef,
    protected readonly mapsLoaderService: MapsLoaderService,
    protected readonly geoLocationService: GeoLocationService,
    private readonly modalService: NgbModal
  ) {
    super(mapsLoaderService, geoLocationService);
  }

  ngOnInit(): void {
    this.initMap();
  }

  protected initMap() {
    super.initMap(this.mapElement, null);

    if(this.focusView) {
      this.map.overlayMapTypes.insertAt(0, new DarkOverlayMapType(new google.maps.Size(256, 256)));
    }

    google.maps.event.addListenerOnce(this.map, 'idle', () => {
      this.mapLoaded = true;
      this.changeDetectorRef.detectChanges();

      this.onMapLoaded();
    });
  }

  private onMapLoaded() {
    this.initMarkers();
  }

  private initMarkers() {
    this.emergenciesList.forEach(s => {
      const marker = this.createMarker(s);
      this.signalMarkersList.push(marker);
    });

    this.fitMapZoom();
  }

  private createMarker(emergency: Emergency, showOnMap: boolean = true) {


    const incidentMarker = new google.maps.marker.AdvancedMarkerElement({
      map: showOnMap ? this.map : null,
      position: {
        lat: +emergency.latitude,
        lng: +emergency.longitude
      },
      gmpDraggable: false,
      //content: markerWrapper
    });

    const contentString = `
      <div id="content">
        <h2 id="firstHeading" class="firstHeading" style="font-weight:bold;">${emergency.title}</h2>
        <div id="bodyContent">
          <p>${emergency.description.replace(/\n/g, '<br>')}</p>
          <button id="viewSignalBtn" class="btn btn-primary">Детайли</button>
        </div>
      </div>`;

    incidentMarker.addListener('click', () => {
      if (!this.infowindow) {
        this.infowindow = new google.maps.InfoWindow({
          maxWidth: 300
        });
      }

      this.infowindow.setContent(contentString);
      this.infowindow.open({
        anchor: incidentMarker,
        map: this.map,
        shouldFocus: false,
      });

      // Listen for button click in the InfoWindow
      google.maps.event.addListenerOnce(this.infowindow, 'domready', () => {
        document.getElementById('viewSignalBtn').addEventListener('click', () => {
          this.openSignal(emergency);
        });
      });
    });

    return incidentMarker;
  }

  private fitMapZoom() {
    const latLngBounds = this.getMarkersLatLngBounds();
    this.map.fitBounds(latLngBounds);
  }

  private getMarkersLatLngBounds(): google.maps.LatLngBounds {
    const latLngBounds = new google.maps.LatLngBounds();
    this.signalMarkersList.forEach(m => {
      latLngBounds.extend(m.position);
    });

    return latLngBounds;
  }

  private updateInfoWindow(signalTitle) {
    if(this.infowindow) {
      this.infowindow.setContent(signalTitle);
    }
  }

  private openSignal(emergency: Emergency) {

  }
}
